import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserAddModelComponent } from '../user-add-model/user-add-model.component';
import { UserQrGeneratorModelComponent } from '../user-qr-generator-model/user-qr-generator-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { Location } from '@angular/common'
@Component({
  selector: 'app-user-role-view',
  templateUrl: './user-role-view.component.html',
  styleUrls: ['./user-role-view.component.sass']
})
export class UserRoleViewComponent {
  public defaultUpdateId = '';
  addUserObj: any = {};
  orgList = []
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  agenda
  dinning
  speaking_engagement
  userId = '';
  orgName = [];
  userList = [];
  gateName = [];
  presentDate = new Date();
  presentMonth = this.presentDate.getMonth() + 1;
  year = this.presentDate.getFullYear();
  meridian = true;
  time = { hour: this.presentDate.getHours(), minute: this.presentDate.getMinutes() };
  date = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() };
  constructor(private route: ActivatedRoute, private location: Location, private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService, private _function: FunctionsService) { }
  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.getUserRoleDetails()
  }
  back() {
    this.location.back();
  }
  async getUserRoleDetails() {
    let wheredata = []
    wheredata = [{ 'field': '`qr_user_role`.`id`', 'value': this.userId, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/user_role_list";
    this._adminService.post(url, data).subscribe(async (response) => {
      if (response.success == true) {
        this.addUserObj = response.data[0]
        this.agenda=this.addUserObj.agenda
        this.dinning=this.addUserObj.dinning
        this.speaking_engagement=this.addUserObj.speaking_engagement
   
  
        
      }
    })
  }
  getGateName(ids){
    // let data = {gate_ids:ids };
    // let url = "qr/gate_name";
    // this._adminService.post(url, data).subscribe(async (response) => {
    //   if (response.success == true) {
    //     return response.data
    //   }
    // }) 
  }

}